import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

/** Nothing to show, said as what is true, and how something comes to be here; on a pane, as every word is. */
export function EmptyState({
  icon: Icon,
  title,
  children,
}: {
  icon: LucideIcon
  title: ReactNode
  children?: ReactNode
}) {
  return (
    <div className="glass-pane flex flex-col items-center gap-2 rounded-card p-8 text-center">
      <Icon aria-hidden="true" className="size-8 text-text-muted" />
      <p className="font-medium">{title}</p>
      {children ? <div className="max-w-prose text-sm text-text-muted">{children}</div> : null}
    </div>
  )
}
